import React, { useState, useEffect, useCallback } from 'react';
import {
    MDBContainer,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBDataTableV5
} from 'mdbreact';
import moment from 'moment';

const FullScreenTable = ({ dataTable: fetchDataTable, ShowFullscreen }) => {
    const [modal] = useState(true);
    const [dataTable, setDataTable] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const serviceData = await fetchDataTable();
                
                if (!serviceData || !serviceData.length) return;
                
                // Build columns
                const columns = Object.keys(serviceData[0]).map(key => ({
                    label: key,
                    field: key,
                    width: key === 'GlobalID' ? 300 : 200
                }));
                
                // Process rows with date formatting
                const rows = serviceData.map(data => {
                    const formattedData = { ...data };
                    
                    Object.keys(formattedData).forEach(key => {
                        if (typeof data[key] === 'string' && moment(data[key]).isValid()) {
                            formattedData[key] = moment(data[key]).format('MM/DD/YYYY');
                        }
                    });
                    
                    return formattedData;
                });
                
                setDataTable({ columns, rows });
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [fetchDataTable]);

    const toggleModal = useCallback(() => {
        ShowFullscreen();
    }, [ShowFullscreen]);

    return (
        <MDBContainer>
            <MDBModal isOpen={modal} toggle={toggleModal} size="fluid">
                <MDBModalHeader toggle={toggleModal}>Data Table</MDBModalHeader>
                <MDBModalBody>
                    {dataTable.columns && (
                        <MDBDataTableV5
                            hover
                            className='modalDataTableCSS'
                            responsiveSm={true}
                            scrollX
                            entriesOptions={[5, 20, 25]}
                            entries={5}
                            pagesAmount={4}
                            data={dataTable}
                            fullPagination
                            searchTop
                            searchBottom={false}
                        />
                    )}
                </MDBModalBody>
            </MDBModal>
        </MDBContainer>
    );
};

export default FullScreenTable;
